import React from 'react';
import { HALL_FILTER_DATA } from '@src/utils/weddingHall';
import { TFilterTag } from '@src/types/weddingHallFilter';

type Item = typeof HALL_FILTER_DATA[keyof typeof HALL_FILTER_DATA][number];
interface ISelectAbleButtons {
	items: Item[];
	onSelect: (value: TFilterTag, type: Item) => void;
  tags: TFilterTag[];
}

const SelectAbleButtons = ({items, onSelect, tags}: ISelectAbleButtons) => {
	return (
		<div>
			<ul className="selectable-list-wrap line-brown font-size-up items-3">
				{items.map(type => (
				<li onClick={() => {
					const value: TFilterTag = {
						name: type.name,
						typeName: type.typeName,
						paramName: type.key as string,
						value: type.value
					}
					onSelect(value, type);
				}} key={`selectable-list-${type.key}-${type.name}`}>
					<div className={`${tags?.some(tag => tag.value === type.value) ? 'on' : ''}`}>{type.name}</div>
				</li>
				))}
			</ul>
		</div>
	);
};

export default SelectAbleButtons;